import { t } from '@transifex/native'

const translationMappings: { [key in string]: string } = {
  '/registration': t('Registration'),
  '/registration/choose-action': t('New Qlocx Space'),
  no_candidates: t('No nearby devices'),
  generic: t('Something went wrong. Please try again.'),
  timeout: t('Something went wrong. Please try again.'),
  'missing_permission:BLUETOOTH_SCAN': t('Please allow the app to use Bluetooth.'),
  'missing_permission:BLUETOOTH_CONNECT': t('Please allow the app to use Bluetooth.'),
  'missing_permission:ACCESS_FINE_LOCATION': t('Please allow the app to use location services.'),
  'missing_permission:ACCESS_COARSE_LOCATION': t('Please allow the app to use location services.'),
  'missing_permission:ACCESS_LOCATION': t('Please allow the app to use location services.'),
  'missing_permission:BLUETOOTH_ENABLED': t('Please enable Bluetooth on your phone.'),
  'missing_permission:NETWORK_ENABLED': t('Please enable Internet on your phone.'),
  'missing_permission:LOCATION_ENABLED': t("Please enable location services in your phone's settings."),
  'missing_permission:ACCESS_BLUETOOTH': t('Please allow the app to use Bluetooth.'),
}

// Added for Transifex to find the strings and translate correctly
const translations = [t('Registration'), t('Deliveries'), t('Smart Storage'), t('Rental'), t('Parcel Locker'), t('Click & Collect'), t('No locks found')]

console.log(translations, translationMappings)

export default translationMappings
